import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const NewReportPage = lazy(() => import('../pages/NewReportPage'));
const ReportTripAndStopPage = lazy(() => import('../modules/TripsAndStopsReportPage/ReportTripAndStopPage'));
const ReportTripAndStopDetailsPage = lazy(() => import('../modules/TripsAndStopsReportPage/ReportTripAndStopDetailsPage'));
const ReportTripAndStopDailyPage = lazy(() => import('../modules/TripsAndStopsReportPage/ReportTripAndStopDailyPage'));
const ReportFleetSafetyPage = lazy(() => import('../modules/FleetSafetyReportPage'));
const ReportSafetyEventsPage = lazy(() => import('../modules/SafetyEventsReportPage'));

const routes = [
  {
    path: Location.REPORTS_NEW,
    component: NewReportPage,
    routes: [
      {
        title: 'Relatório de trajetos e paradas detalhada',
        path: Location.REPORTS_TRIP_AND_STOP_DETAILS,
        exact: true,
        component: ReportTripAndStopDetailsPage,
      },
      {
        title: 'Relatório de trajetos e paradas diário',
        exact: true,
        path: Location.REPORTS_TRIP_AND_STOP_DAILY,
        component: ReportTripAndStopDailyPage,
      },
      {
        title: 'Relatório de trajetos e paradas',
        path: Location.REPORTS_TRIP_AND_STOP_TYPE,
        exact: true,
        component: ReportTripAndStopPage,
      },
      {
        title: 'Relatório de eventos de segurança',
        path: Location.REPORTS_FLEET_SAFETY_TYPE,
        exact: true,
        component: ReportFleetSafetyPage,
      },
      {
        title: 'Relatório de eventos de segurança detalhado',
        path: Location.REPORTS_SAFETY_EVENTS,
        exact: true,
        component: ReportSafetyEventsPage,
      },
    ],
  },
];

export default routes;
